import type { StateInfo } from "../types.js";

export const GST_STATE_CODES: Record<string, StateInfo> = {
  "01": { code: "01", name: "Jammu & Kashmir", type: "ut" },
  "02": { code: "02", name: "Himachal Pradesh", type: "state" },
  "03": { code: "03", name: "Punjab", type: "state" },
  "04": { code: "04", name: "Chandigarh", type: "ut" },
  "05": { code: "05", name: "Uttarakhand", type: "state" },
  "06": { code: "06", name: "Haryana", type: "state" },
  "07": { code: "07", name: "Delhi", type: "ut" },
  "08": { code: "08", name: "Rajasthan", type: "state" },
  "09": { code: "09", name: "Uttar Pradesh", type: "state" },
  "10": { code: "10", name: "Bihar", type: "state" },
  "11": { code: "11", name: "Sikkim", type: "state" },
  "12": { code: "12", name: "Arunachal Pradesh", type: "state" },
  "13": { code: "13", name: "Nagaland", type: "state" },
  "14": { code: "14", name: "Manipur", type: "state" },
  "15": { code: "15", name: "Mizoram", type: "state" },
  "16": { code: "16", name: "Tripura", type: "state" },
  "17": { code: "17", name: "Meghalaya", type: "state" },
  "18": { code: "18", name: "Assam", type: "state" },
  "19": { code: "19", name: "West Bengal", type: "state" },
  "20": { code: "20", name: "Jharkhand", type: "state" },
  "21": { code: "21", name: "Odisha", type: "state" },
  "22": { code: "22", name: "Chhattisgarh", type: "state" },
  "23": { code: "23", name: "Madhya Pradesh", type: "state" },
  "24": { code: "24", name: "Gujarat", type: "state" },
  "26": { code: "26", name: "Dadra & Nagar Haveli and Daman & Diu", type: "ut" },
  "27": { code: "27", name: "Maharashtra", type: "state" },
  "29": { code: "29", name: "Karnataka", type: "state" },
  "30": { code: "30", name: "Goa", type: "state" },
  "31": { code: "31", name: "Lakshadweep", type: "ut" },
  "32": { code: "32", name: "Kerala", type: "state" },
  "33": { code: "33", name: "Tamil Nadu", type: "state" },
  "34": { code: "34", name: "Puducherry", type: "ut" },
  "35": { code: "35", name: "Andaman & Nicobar Islands", type: "ut" },
  "36": { code: "36", name: "Telangana", type: "state" },
  "37": { code: "37", name: "Andhra Pradesh", type: "state" },
  "38": { code: "38", name: "Ladakh", type: "ut" },
  "97": { code: "97", name: "Other Territory", type: "ut" },
};
